/* Healthy Mithai - slow, large, bottom-to-top festive fireworks */
(function () {
  'use strict';
  if (window.__hmRocketFireworksV4) return;
  window.__hmRocketFireworksV4 = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.createElement('canvas');
  canvas.id = 'hm-home-fireworks';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:25;pointer-events:none;overflow:hidden;';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  if (!ctx) { canvas.remove(); return; }

  var w = 0, h = 0, dpr = 1, rockets = [], particles = [];
  var lastLaunch = 0, mobile = window.matchMedia('(max-width: 749px)').matches;
  var palette = [
  '#FFD700', // Rich Gold
  '#FFC000', // Golden Yellow
  '#E5AA36', // Antique Gold
  '#F4C95D', // Warm Champagne
  '#DAA520', // Goldenrod
  '#FFDF80', // Light Gold
  '#B8860B', // Dark Goldenrod
  '#F0B849', // Amber Gold
  '#FFF0B3'  // Soft Champagne
];

  function resize() {
    w = window.innerWidth; h = window.innerHeight;
    dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    mobile = window.matchMedia('(max-width: 749px)').matches;
  }
  function color() { return palette[(Math.random() * palette.length) | 0]; }

  // Launch two rockets together from separate positions at the bottom.
  function launch() {
    var positions = [0.30 + Math.random() * 0.12, 0.58 + Math.random() * 0.12];
    for (var n = 0; n < 2; n++) {
      var x = w * positions[n];
      var targetX = x + (Math.random() - 0.5) * w * (mobile ? 0.10 : 0.16);
      var targetY = h * (0.10 + Math.random() * 0.26);
      var travel = Math.max(1, h - targetY);
      var duration = mobile ? 1550 + Math.random() * 250 : 1750 + Math.random() * 250;
      rockets.push({
        x: x, y: h + 14, startX: x, targetX: targetX, targetY: targetY,
        vx: (targetX - x) / (duration / 16.67),
        vy: -travel / (duration / 16.67),
        age: 0, color: color(), trail: []
      });
    }
  }

  function particle(x, y, angle, speed, c, size, life, gravity) {
    particles.push({
      x: x, y: y, oldX: x, oldY: y,
      vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
      color: c, size: size, life: life, maxLife: life, gravity: gravity
    });
  }

  function burst(x, y, main) {
    var count = mobile ? 118 : 176;
    var secondary = color();
    var tertiary = color();
    // Large layered circular burst in deep festive tones.
    for (var i = 0; i < count; i++) {
      var a = Math.PI * 2 * i / count + (Math.random() - 0.5) * 0.055;
      var s = 2.5 + Math.random() * (mobile ? 2.8 : 3.6);
      var c = i % 4 === 0 ? '#D4AF65' : (i % 3 === 0 ? secondary : (i % 2 === 0 ? main : tertiary));
      particle(x, y, a, s, c, 2.8 + Math.random() * 2.6, 125 + Math.random() * 40, 0.010);
    }
    // Inner ring adds a dense, bright centre without using neon colours.
    var inner = mobile ? 42 : 64;
    for (var j = 0; j < inner; j++) {
      var a2 = Math.PI * 2 * j / inner;
      particle(x, y, a2, 1.0 + Math.random() * 1.2, '#E1BD79',
        2.2 + Math.random() * 1.8, 75 + Math.random() * 30, 0.006);
    }
    // A few long gold sparks extend the shape and linger.
    for (var k = 0; k < (mobile ? 16 : 24); k++) {
      var a3 = Math.random() * Math.PI * 2;
      particle(x, y, a3, 3.0 + Math.random() * 1.5, '#B8863B',
        1.8 + Math.random() * 1.4, 125 + Math.random() * 25, 0.008);
    }
  }

  function paintRocket(r) {
    r.trail.push({ x: r.x, y: r.y });
    if (r.trail.length > 24) r.trail.shift();
    for (var i = 0; i < r.trail.length; i++) {
      var t = r.trail[i];
      var alpha = (i + 1) / r.trail.length * 0.62;
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.arc(t.x, t.y, 1.3 + (i / r.trail.length) * 2.0, 0, Math.PI * 2);
      ctx.fillStyle = r.color;
      ctx.shadowBlur = 12;
      ctx.shadowColor = r.color;
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    ctx.beginPath();
    ctx.arc(r.x, r.y, mobile ? 4.0 : 4.8, 0, Math.PI * 2);
    ctx.fillStyle = '#E7C98B';
    ctx.shadowBlur = 17;
    ctx.shadowColor = r.color;
    ctx.fill();
    ctx.shadowBlur = 0;
  }

  var running = false;
  function animate(now) {
    if (document.hidden) { running = false; return; }
    ctx.clearRect(0, 0, w, h);

    // Deliberate pacing: one large rocket at a time, with a pause between launches.
    var interval = 3500;
    var maxParticles = mobile ? 620 : 980;
    if (now - lastLaunch > interval && rockets.length < 4 && particles.length < maxParticles) {
      launch();
      lastLaunch = now;
    }

    for (var r = rockets.length - 1; r >= 0; r--) {
      var q = rockets[r];
      q.x += q.vx; q.y += q.vy; q.age++;
      paintRocket(q);
      if (q.y <= q.targetY) {
        burst(q.x, q.y, q.color);
        rockets.splice(r, 1);
      }
    }

    for (var p = particles.length - 1; p >= 0; p--) {
      var a = particles[p];
      a.oldX = a.x; a.oldY = a.y;
      a.x += a.vx; a.y += a.vy;
      a.vx *= 0.992;
      a.vy = a.vy * 0.992 + a.gravity;
      a.life--;
      if (a.life <= 0) { particles.splice(p, 1); continue; }
      var alpha = Math.min(1, a.life / (a.maxLife * 0.35));
      ctx.globalAlpha = alpha;
      ctx.beginPath();
      ctx.moveTo(a.oldX, a.oldY);
      ctx.lineTo(a.x, a.y);
      ctx.strokeStyle = a.color;
      ctx.lineWidth = a.size;
      ctx.lineCap = 'round';
      ctx.shadowBlur = 8;
      ctx.shadowColor = a.color;
      ctx.stroke();
      ctx.shadowBlur = 0;
    }
    ctx.globalAlpha = 1;
    requestAnimationFrame(animate);
  }

  function start() {
    if (!running && !document.hidden) {
      running = true;
      lastLaunch = performance.now() - 1800;
      requestAnimationFrame(animate);
    }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) running = false;
    else start();
  });
  window.addEventListener('resize', resize, { passive: true });
  resize();
  start();
})();
